import axios from '@/plugins/axios'

export function getProfitOrders(params = {}) {
  return axios.get('profit', {
    params,
  })
}

export function getProfitStatistics(params = {}) {
  return axios.get('profit/statistics', {
    params,
  })
}

export function getProfitTotal(params = {}) {
  return axios.get('profit/profitTotal', {
    params,
  })
}
